var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2671 107.091L106.695 97.6624L146.765 137.731L137.337 147.159L97.2671 107.091Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 13.7899C52.5217 13.7899 38.9562 19.4089 28.9542 29.4108C18.9523 39.4128 13.3333 52.9783 13.3333 67.1232C13.3333 81.2681 18.9523 94.8336 28.9542 104.836C38.9562 114.838 52.5217 120.457 66.6666 120.457C80.8115 120.457 94.377 114.838 104.379 104.836C114.381 94.8336 120 81.2681 120 67.1232C120 52.9783 114.381 39.4128 104.379 29.4108C94.377 19.4089 80.8115 13.7899 66.6666 13.7899Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.187 118.26L117.615 108.831L146.607 137.822L137.179 147.251L108.187 118.26Z",
    fill: "#37474F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 23.7899C55.1739 23.7899 44.1519 28.3553 36.0253 36.4819C27.8987 44.6085 23.3333 55.6305 23.3333 67.1232C23.3333 78.6159 27.8987 89.6379 36.0253 97.7645C44.1519 105.891 55.1739 110.457 66.6666 110.457C78.1593 110.457 89.1813 105.891 97.3079 97.7645C105.434 89.6379 110 78.6159 110 67.1232C110 55.6305 105.434 44.6085 97.3079 36.4819C89.1813 28.3553 78.1593 23.7899 66.6666 23.7899Z",
    fill: "#64B5F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6662 47.7899C83.9995 41.1232 75.6662 37.1232 66.6662 37.1232C57.6662 37.1232 49.3328 41.1232 43.6662 47.7899C42.3328 49.1232 42.6662 51.4565 43.9995 52.4565C45.3328 53.7899 47.6662 53.4565 48.6662 52.1232C53.3328 46.7899 59.6662 43.7899 66.6662 43.7899C73.6662 43.7899 79.9995 46.7899 84.6662 52.1232C85.3328 52.7899 86.3328 53.4565 87.3328 53.4565C87.9995 53.4565 88.9995 53.1232 89.3328 52.7899C90.6662 51.4565 90.6662 49.1232 89.6662 47.7899Z",
    fill: "#BBDEFB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search_2.44264f91.svg";
export { ForwardRef as ReactComponent };